import { render, staticRenderFns } from "./SnippetTextForm.vue?vue&type=template&id=7fb5da53&scoped=true&"
import script from "./SnippetTextForm.vue?vue&type=script&lang=js&"
export * from "./SnippetTextForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb5da53",
  null
  
)

export default component.exports